const awsconfig_samaral = {
    aws_project_region: "us-east-1",
  
    // APPSYNC (FROM GENERATE_AWS_EXPORTS.SH)
    aws_appsync_graphqlEndpoint: "https://zuby56m5gffknb5moaizdw33fa.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "API_KEY",
    aws_appsync_apiKey: "da2-qdn3jpykzracnnwfzvuzsdtnhm", // FROM AWS APPSYNC > SETTINGS // EXPIRES AFTER & DAYS
    aws_appsync_apiId: "ysaimre2pbgqdk34ld4z5luxnm", // FROM AWS APPSYNC > SETTINGS
    aws_appsync_arn: "arn:aws:appsync:us-east-1:017438705622:apis/ysaimre2pbgqdk34ld4z5luxnm",
  
    // COGNITO
    aws_cognito_identity_pool_id_auth0: "us-east-1:b6fb482a-652c-486d-b1dd-13ca92c17202", //
    aws_cognito_identity_pool_id: "us-east-1:26611a36-374c-4527-82ad-9e1d6fe330d5", // FROM AWS COGNITO > ID POOL > SAMPLE CODE
  };
  
  export default awsconfig_samaral;
  